import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * useQrCode — generates a data:image/png QR code from a URL on the client side.
 * Ensures the QR always encodes the current domain (no stale preview URLs).
 */
export const useQrCode = (url, opts = {}) => {
  const [dataUrl, setDataUrl] = useState('');

  useEffect(() => {
    let cancelled = false;
    if (!url) {
      setDataUrl('');
      return;
    }
    QRCode.toDataURL(url, {
      width: opts.width || 512,
      margin: opts.margin ?? 2,
      color: {
        dark: opts.dark || '#000000',
        light: opts.light || '#FFFFFF',
      },
    })
      .then((d) => {
        if (!cancelled) setDataUrl(d);
      })
      .catch(() => {
        if (!cancelled) setDataUrl('');
      });
    return () => {
      cancelled = true;
    };
  }, [url, opts.width, opts.margin, opts.dark, opts.light]);

  return dataUrl;
};
